import { RptSumItem } from '../types';

/**
 * 분석 Report의 차이(기준 − 비교대상) 계산 — **표시값 기준**이다.
 *
 * 기준·비교대상 칸은 원본(MSR_NVL)을 각각 소수 1자리로 반올림해 보여주는데, 차이를
 * 원본으로 계산하면 화면 숫자끼리 검산이 안 된다(예: 4.65/5.04 → 표시 4.7/5.0,
 * 원본 차이 −0.4, 표시 차이 −0.3). 그래서 반올림한 뒤 뺀다.
 *
 * 부호는 화면 라벨과 같은 `기준 − 비교대상`이다. BE의 SHRT_QTY도 같은 기준이라,
 * 기준값이 없는 구 리포트에서는 그 값으로 대체해도 부호가 뒤집히지 않는다.
 */
const round1 = (v: number): number => Math.round(v * 10) / 10;

export const rptSumDiff = (item: RptSumItem): number | null => {
  const mst = item.values.MST;
  const tgt = item.values.TGT;
  if (mst == null || tgt == null) return item.shrtQty;
  return round1(mst) - round1(tgt);
};
